export interface TableColorScheme {
  header: string;
  color1: string;
  color2: string;
}

export enum TableStylePreset {
  Blue = 'blue',
  Green = 'green',
  Purple = 'purple',
  Brown = 'brown',
  DeepRed = 'deepRed',
  Gray = 'gray',
  Custom = 'custom',
}
export const DEFAULT_EMAIL_TABLE_STYLE = TableStylePreset.Gray;
export const DEFAULT_TABLE_STYLE = TableStylePreset.Blue;

export const DEFAULT_TABLE_STYLES: Record<TableStylePreset, TableColorScheme> = {
  [TableStylePreset.Blue]: {
    header: '#1976d2',
    color1: '#bbdefb',
    color2: '#e3f2fd',
  },
  [TableStylePreset.Green]: {
    header: '#2e7d32',
    color1: '#c8e6c9',
    color2: '#e8f5e9',
  },
  [TableStylePreset.Purple]: {
    header: '#7b1fa2',
    color1: '#e1bee7',
    color2: '#f3e5f5',
  },
  [TableStylePreset.Brown]: {
    header: '#795548',
    color1: '#d7ccc8',
    color2: '#efebe9',
  },
  [TableStylePreset.DeepRed]: {
    header: '#c62828',
    color1: '#ffcdd2',
    color2: '#ffebee',
  },
  [TableStylePreset.Gray]: {
    header: '#f3f4f6',
    color1: '#f8fafc',
    color2: '#ffffff',
  },
  [TableStylePreset.Custom]: {
    header: '',
    color1: '',
    color2: '',
  },
};
